module.exports = __webpack_public_path__ + "TriominoLogo.png";